import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseURL = import.meta.env.VITE_API_BASE_URL;

export const fetchAiSearchParts = createAsyncThunk(
  "aiSearch/fetchParts",
  async (query, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseURL}/ai-search/parts`, {
        query
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "AI search request failed"
      );
    }
  }
);
